import React, { Component } from 'react';
import { Notification } from './components/Notification';
import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
        <Notification/>
    );
  }
}
